/* Outils partagés par les scripts du thème Whoosh. */
(function () {
  var W = (window.Whoosh = window.Whoosh || {});

  /* Prix au format de la maquette : 11900 -> « 119 € », 11990 -> « 119,90 € ». */
  W.prix = function (cents) {
    var c = Math.round(Number(cents) || 0);
    if (c % 100 === 0) return c / 100 + " €";
    return (c / 100).toFixed(2).replace(".", ",") + " €";
  };

  /* Ajout au panier : tous les boutons passent par l'événement de la maquette.
     detail = { items: [{ id: <id de variante>, quantity: 1, properties: {...} }] } */
  W.ajouter = function (items) {
    window.dispatchEvent(new CustomEvent("tpl-panier:ajouter", { detail: { items: items } }));
  };
})();
